export const isValidNip = (nip) => {
  if (!/^\d{10}$/.test(nip)) {
    return false;
  }

  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];

  const sum = weights.reduce(
    (total, weight, index) =>
      total + Number(nip[index]) * weight,
    0
  );

  const checksum = sum % 11;

  return checksum !== 10 && checksum === Number(nip[9]);
};